<div class="bs-block">
  <div class="bs-title-block">
    <span></span>
    <span class="top-bar-text main-text-color">{{'Прикріпити'}}</span>
    <mat-icon class="back-icon main-text-color" (click)="closeBottomSheet()">close</mat-icon>
  </div>
  <div class="bs-button-block">
    <div (click)="openLink('image')" class="bs-button button-border-color">
      <div class="bs-button-main">
        <mat-icon class="bs-icon accent-color" fontSet="material-icons-outlined">photo_camera</mat-icon>
        <span class="bs-text button-text-color">{{'Фото'}}</span>
      </div>
      <div class="bs-button-description hint-color">
        {{'png\\jpeg\\jpg до 100 мб.'}}
      </div>
    </div>
    <div (click)="openLink('video')" class="bs-button button-border-color">
      <div class="bs-button-main">
        <mat-icon class="bs-icon accent-color" fontSet="material-icons-outlined">videocam</mat-icon>
        <span class="bs-text button-text-color">{{'Відео'}}</span>
      </div>
      <div class="bs-button-description hint-color">
        {{'до 100 мб.'}}
      </div>
    </div>
<!--    <div (click)="openLink('file')" class="bs-button button-border-color">-->
<!--      <div class="bs-button-main">-->
<!--        <mat-icon class="bs-icon accent-color" fontSet="material-icons-outlined">description</mat-icon>-->
<!--        <span class="bs-text button-text-color">{{'Файл'}}</span>-->
<!--      </div>-->
<!--      <div class="bs-button-description hint-color">-->
<!--        {{'до 16 мб.'}}-->
<!--      </div>-->
<!--    </div>-->
<!--    <div (click)="openLink('audio')" class="bs-button button-border-color">-->
<!--      <div class="bs-button-main">-->
<!--        <mat-icon class="bs-icon accent-color" fontSet="material-icons-outlined">volume_up</mat-icon>-->
<!--        <span class="bs-text button-text-color">{{'Аудіо'}}</span>-->
<!--      </div>-->
<!--      <div class="bs-button-description hint-color">-->
<!--        {{'до 16 мб.'}}-->
<!--      </div>-->
<!--    </div>-->
  </div>
</div>
